export { SkeletonMultiline as Multiline } from './primitives/SkeletonMultiline';
export { SkeletonTitle as Title } from './primitives/SkeletonTitle';
export { SkeletonAvatar as Avatar } from './primitives/SkeletonAvatar';
export { SkeletonButton as Button } from './primitives/SkeletonButton';
export { SkeletonLine as Line } from './primitives/SkeletonLine';
